/**
 * swBridge.js — Service Worker Update Bridge
 *
 * Communicates with the service worker to trigger updates.
 * Used by the "Update Now" banner in App.js.
 */

/**
 * Send SKIP_WAITING to the waiting service worker, then reload on controllerchange.
 * This triggers the new SW to activate and the page to reload with fresh code.
 */
export function applyUpdate() {
  navigator.serviceWorker.getRegistration().then((reg) => {
    if (reg?.waiting) {
      reg.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  });

  // Reload once the new service worker takes over
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload();
  }, { once: true });
}
